import QualificacaoModal from "../modals/QualificacaoModal";
import React, { useState, useEffect } from "react";
import RequestService from "../../services/RequestService";
import { useOutletContext } from 'react-router-dom';
import { FaCircle } from "react-icons/fa";
import { parseISO, format, addDays, differenceInCalendarDays } from "date-fns";
import RequestDetailsModal from "../modals/RequestDetailsModal";
import { FaLongArrowAltDown } from "react-icons/fa";
import StatusRequests from '../../enums/StatusRequests'
import { HiOutlineDocumentReport } from "react-icons/hi";
import { toast } from "react-toastify";


export default function Qualificacao() {
  // Modal Qualificação
  const [qualificacaoModalOpen, setQualificacaoModalOpen] = useState(false);
  const [qualificacaoRequestId, setQualificacaoRequestId] = useState(null);
  // Abre modal de qualificação
  const handleOpenQualificacaoModal = (requestId) => {
    setQualificacaoRequestId(requestId);
    setQualificacaoModalOpen(true);
  };

  const [requestList, setRequestList] = useState({ requests: [], totalPages: 1 });
  const [currentPageRequests, setCurrentPageRequests] = useState(null);
  const [requestDetailsModal, setRequestDetailsModal] = useState(false);
  const [requestOnDetailsModal, setRequestOnDetailsModal] = useState();

  const { user } = useOutletContext();

  const MAX_RANGE_DAYS = 90;
  const whiteListEmails = ['junior.silva@amerinode.com.br', 'guilherme.alberto@amerinode.com.br', 'jean.medeiros@amerinode.com.br'];


  //filters
  const [searchIdRequest, setSearchIdRequest] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [startDateEntrega, setStartDateEntrega] = useState('');
  const [endDateEntrega, setEndDateEntrega] = useState('');
  
  const fetchRequests = async (page = 1) => {
    if(page === 1){
      setCurrentPageRequests(1); // Reseta a página atual para 1 quando uma nova busca é feita
    }
    const itemsPerPage = 15;
    try {
      const requestsNovas = await RequestService.getQualificationReport({
        params: {
          searchIdRequest,
          startDate,
          endDate,
          startDateEntrega,
          endDateEntrega,
          page,
          itemsPerPage
        }
      });
      if (requestsNovas) {
        setRequestList(requestsNovas);
        toast.success("Relatório gerado!");
      } else {
        toast.error("Ops! Não foi possível gerar o relatório!");
      }
    } catch (error) {
      toast.error(error?.message || "Ops! Não foi possível gerar o relatório!");
    }
  };

  const clampEndToMaxRange = (startStr, endStr) => {
    try {
      const start = parseISO(startStr);
      const end = parseISO(endStr);
      const diff = differenceInCalendarDays(end, start);
      if (diff > MAX_RANGE_DAYS) {
        const capped = addDays(start, MAX_RANGE_DAYS);
        return format(capped, "yyyy-MM-dd"); // value for <input type="date">
      }
      return endStr;
    } catch (e) {
      return endStr;
    }
  };

  const handleSearch = () => {
    // Impede chamada sem filtro de data
    if ( (!(startDate || endDate) && !(startDateEntrega || endDateEntrega)) && !searchIdRequest ) {
      toast.error("É obrigatório informar pelo menos um intervalo de datas (Aberto ou Entregue) ou um ID de requisição.");
      return;
    }

    // valida intervalo "Aberto de / até"
    if (startDate && endDate) {
      try {
        const diff = differenceInCalendarDays(parseISO(endDate), parseISO(startDate));
        if (diff > MAX_RANGE_DAYS && !whiteListEmails.includes(user.email)) {
          toast.error(`Intervalo 'Aberto' não pode ser maior que ${MAX_RANGE_DAYS} dias.`);
          return;
        }
      } catch (e) {
        toast.error("Datas inválidas no filtro 'Aberto'.");
        return;
      }
    }

    // valida intervalo "Entregue de / até"
    if (startDateEntrega && endDateEntrega) {
      try {
        const diffEntrega = differenceInCalendarDays(parseISO(endDateEntrega), parseISO(startDateEntrega));
        if (diffEntrega > MAX_RANGE_DAYS && !whiteListEmails.includes(user.email)) {
          toast.error(`Intervalo 'Entregue' não pode ser maior que ${MAX_RANGE_DAYS} dias.`);
          return;
        }
      } catch (e) {
        toast.error("Datas inválidas no filtro 'Entregue'.");
        return;
      }
    }

    // tudo ok -> chama a busca
    fetchRequests(1); // Chama a busca na página 1
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= requestList.totalPages) {
      fetchRequests(newPage); // Chama a busca na página selecionada
    }
    setCurrentPageRequests(newPage); // Atualiza o estado da página atual
  };

  // useEffect(() => {
  //   if (currentPageRequests !== null) {
  //     fetchRequests(currentPageRequests); // Só chama fetchRequests se currentPageRequests não for null
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentPageRequests]);
  

  const handleRequestDetailsModal = async (ticketId) => {
    setRequestDetailsModal(true)
    setRequestOnDetailsModal(ticketId)
  };

  const clearFilters = () => {
    setSearchIdRequest('');
    setStartDate('');
    setEndDate('');
    setStartDateEntrega('');
    setEndDateEntrega('');
    setRequestList({ requests: [], totalPages: 1 });
    // setStatus('');
  };

  const handleStartDateChange = (e) => {
    const val = e.target.value;
    setStartDate(val);

    if (endDate) {
      try {
        const diff = differenceInCalendarDays(parseISO(endDate), parseISO(val));
        if (diff > MAX_RANGE_DAYS && !whiteListEmails.includes(user.email)) {
          toast.warn(`Intervalo 'Aberto' maior que ${MAX_RANGE_DAYS} dias. Ao clicar em Buscar a consulta será bloqueada.`);
        }
      } catch (err) {
        // ignore parse errors here
      }
    }
    console.log(val);
  };

  const handleEndDateChange = (e) => {
    const val = e.target.value;
    setEndDate(val);

    if (startDate) {
      try {
        const diff = differenceInCalendarDays(parseISO(val), parseISO(startDate));
        if (diff > MAX_RANGE_DAYS && !whiteListEmails.includes(user.email)) {
          toast.warn(`Intervalo 'Aberto' maior que ${MAX_RANGE_DAYS} dias. Ao clicar em Buscar a consulta será bloqueada.`);
        }
      } catch (err) {
        // ignore parse errors here
      }
    }
    console.log(val);
  };

  const handleStartDateEntregaChange = (e) => {
    const val = e.target.value;
    setStartDateEntrega(val);

    if (endDateEntrega) {
      try {
        const diff = differenceInCalendarDays(parseISO(endDateEntrega), parseISO(val));
        if (diff > MAX_RANGE_DAYS && !whiteListEmails.includes(user.email)) {
          toast.warn(`Intervalo 'Entregue' maior que ${MAX_RANGE_DAYS} dias. Ao clicar em Buscar a consulta será bloqueada.`);
        }
      } catch (err) {
        // ignore parse errors here
      }
    }
    console.log(val);
  };

  const handleEndDateEntregaChange = (e) => {
    const val = e.target.value;
    setEndDateEntrega(val);

    if (startDateEntrega) {
      try {
        const diff = differenceInCalendarDays(parseISO(val), parseISO(startDateEntrega));
        if (diff > MAX_RANGE_DAYS && !whiteListEmails.includes(user.email)) {
          toast.warn(`Intervalo 'Entregue' maior que ${MAX_RANGE_DAYS} dias. Ao clicar em Buscar a consulta será bloqueada.`);
        }
      } catch (err) {
        // ignore parse errors here
      }
    }
    console.log(val);
  };




  return (
    <div className="flex w-full h-full justify-center items-center py-4 px-4 bg-gray-200">

      <div className="flex flex-col w-full h-full rounded-xl py-8 px-6 gap-12 bg-white">

      <div className="flex flex-col w-full h-full gap-4 border border-gray-800 border-opacity-40 rounded-xl p-2">

          <div className="flex items-center gap-2 w-full text-sm font-semibold ps-2 mt-2">
            <div className="flex items-center gap-1 w-full">
              <HiOutlineDocumentReport size={20} />
              <p>Consulta Gerencial de Qualificação</p>
            </div>
          </div>

          <div className="flex flex-col justify-between w-full h-full">

            <div className="flex flex-col gap-4 max-h-full">

              {/* FILTROS */}
              <div className="flex flex-wrap gap-2 items-end text-[10px]">

                <div className="flex flex-col w-32">
                  <label className="text-[10px] font-semibold ms-2">Nº Solicitação</label>
                  <input
                    type="text"
                    placeholder="ID Requisição"
                    value={searchIdRequest}
                    onChange={(e) => setSearchIdRequest(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  />
                </div>

                <div className="flex gap-2 rounded-lg bg-zinc-200 px-2">
                  <div className="flex flex-col min-w-32">
                    <label className="text-[10px] font-semibold ms-2">Aberto de</label>
                    <input
                      type="date"
                      placeholder="Start Date"
                      value={startDate}
                      onChange={handleStartDateChange}
                      className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                    />
                  </div>
                  <div className="flex flex-col min-w-32">
                    <label className="text-[10px] font-semibold ms-2">até</label>
                    <input
                      type="date"
                      placeholder="End Date"
                      value={endDate}
                      onChange={handleEndDateChange}
                      className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                    />
                  </div>
                </div>

                <div className="flex gap-2 rounded-lg bg-zinc-200 px-2">
                  <div className="flex flex-col min-w-32">
                    <label className="text-[10px] font-semibold ms-2">Entregue de</label>
                    <input
                      type="date"
                      placeholder="Start Date"
                      value={startDateEntrega}
                      onChange={handleStartDateEntregaChange}
                      className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                    />
                  </div>
                  <div className="flex flex-col min-w-32">
                    <label className="text-[10px] font-semibold ms-2">até</label>
                    <input
                      type="date"
                      placeholder="End Date"
                      value={endDateEntrega}
                      onChange={handleEndDateEntregaChange}
                      className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                    />
                  </div>
                </div>

                <div className="flex gap-2 items-end">
                  {/* <button onClick={handleSubmit} className="bg-zinc-800 hover:bg-zinc-700 text-white h-5 px-4 rounded-2xl w-40">
                  Buscar
                </button> */}
                  <button onClick={clearFilters} className="bg-zinc-800 hover:bg-zinc-700 text-white h-5 px-4 rounded-2xl w-40">
                    Limpar Filtros
                  </button>
                  <button onClick={handleSearch} className="bg-zinc-800 hover:bg-zinc-700 text-white h-5 px-4 rounded-2xl w-40">
                    Buscar
                  </button>
                </div>

              </div>

              {/* TABELA */}
              <div className="w-full mt-4">
                <div className="flex gap-1 ms-2 text-xs">Total: <div className="font-bold">{requestList.totalRequests} registros</div></div>
                <div className="overflow-x-auto">
                  <table className="min-w-full bg-white rounded-lg text-[10px]">
                    <thead className="bg-gray-200">
                      <tr>
                        <th className="py-2 px-4 border-b rounded-tl-lg">Ação</th>
                        <th className="py-2 px-4 border-b">Status Qualificação</th>
                        <th className="py-2 px-4 border-b">UF</th>
                        <th className="py-2 px-4 border-b">Status</th>
                        <th className="py-2 px-4 border-b">Nº Solicitação</th>
                        <th className="py-2 px-4 border-b">Técnico</th>
                        <th className="py-2 px-4 border-b">Empresa</th>
                        <th className="py-2 px-4 border-b">Criado em</th>
                        <th className="py-2 px-4 border-b">Cod Sap</th>
                        <th className="py-2 px-4 border-b">Qtd Solicitada</th>
                        <th className="py-2 px-4 border-b">Qtd Cortada</th>
                        <th className="py-2 px-4 border-b">Qtd Atender</th>
                        <th className="py-2 px-4 border-b">Qtd Atendida</th>
                        <th className="py-2 px-4 border-b">Corte Total</th>
                        <th className="py-2 px-4 border-b">Qtd Pendente</th>
                        <th className="py-2 px-4 border-b">Site</th>
                        <th className="py-2 px-4 border-b">DRS Original</th>
                        <th className="py-2 px-4 border-b">DRS a Atender</th>
                        <th className="py-2 px-4 border-b">GMO</th>
                        <th className="py-2 px-4 border-b">ID Boleto</th>
                        <th className="py-2 px-4 border-b">Tipo Boleto</th>
                        <th className="py-2 px-4 border-b">Atendimento</th>
                        <th className="py-2 px-4 border-b">Telefone</th>
                        <th className="py-2 px-4 border-b"><div className="flex justify-center items-center">Data SLA<FaLongArrowAltDown /></div></th>
                        <th className="py-2 px-4 border-b rounded-tr-lg">Recebido</th>
                        {/* <th className="py-2 px-4 border-b rounded-tr-lg">Ação</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {requestList.requests?.map((request, index) => (
                        <tr key={index} className={`border-b hover:bg-gray-100s`}>
                          <td className="py-1 px-4">
                            <button
                              className="bg-yellow-500 rounded-full px-2 text-white flex items-center justify-center"
                              onClick={() => handleOpenQualificacaoModal(request._id)}
                              style={{ fontSize: '18px', fontWeight: 'bold', width: '24px', height: '24px', padding: 0 }}
                              title="Abrir Qualificação"
                            >
                              +
                            </button>
                          </td>
                          <td className="py-1 px-4">
                            {request.qualificacao ? (
                              <span className="text-blue-600 font-bold">INICIADA</span>
                            ) : (
                              <span className="text-yellow-500 font-bold">PENDENTE</span>
                            )}
                          </td>
                          <td className="py-1 px-4">{request.uf}</td>
                          <td className="py-1 px-4">
                            <div className="flex justify-start items-center gap-2 min-w-28">
                              <FaCircle
                                className="flex-none"
                                color={StatusRequests[request.status]?.cor || "#000000"}
                                size={15}
                              />
                              {request.status}
                            </div>
                          </td>
                          <td className="py-1 px-4 cursor-pointer underline font-bold whitespace-nowrap" onClick={() => handleRequestDetailsModal(request._id)}>{request.idRequest}</td>
                          <td className="py-1 px-4">{request.tecnico || request.nomeSolicitante}</td>
                          <td className="py-1 px-4">{request.empresaTecnico?.socialName || request.empresaSolicitante}</td>
                          <td className="py-1 px-4">{format(parseISO(request.createdAt), 'dd/MM/yy HH:mm')}</td>
                          <td className="py-1 px-4 whitespace-nowrap">{request.codSap}</td>
                          <td className="py-1 px-4 bg-gray-200"><div className="flex justify-center items-center gap-2">{request.quantidadeSolicitada}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.quantidadeCortada}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.quantidadeAtender}</div></td>
                          <td className="py-1 px-4 bg-gray-200"><div className="flex justify-center items-center gap-2">{request.quantidadeAtendida}</div></td>
                          <td className="py-1 px-4 bg-gray-200"><div className="flex justify-center items-center gap-2">{request.quantidadeCortadaTotal}</div></td>
                          <td className="py-1 px-4 bg-gray-200"><div className="flex justify-center items-center gap-2">{request.quantidadePendente}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.site}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.drsOriginal?.sigla}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.drsAtender?.sigla}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.gmo.cidade}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.idBoleto}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-start items-center gap-2 min-w-24">{request.tipoBoleto}</div></td>
                          <td className="py-1 px-4">
                            <div className="flex justify-center items-center gap-2">
                              {["bbn-alta", "bbn-media"].includes(request.tipoAtendimento) ? (
                                <span className="text-black font-bold rounded-lg px-1 bg-yellow-300">
                                  {request.tipoAtendimento.toUpperCase()}
                                </span>
                              ) : (
                                request.tipoAtendimento.toUpperCase()
                              )}
                            </div>
                          </td>
                          <td className="py-1 px-4 whitespace-nowrap">{request.user.phone}</td>
                          <td className="py-1 px-4">
                            {request?.slaDate ? format(parseISO(request.slaDate), 'dd/MM/yy HH:mm') : ""}
                          </td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.dataHoraRecebimento ? format(parseISO(request.dataHoraRecebimento), 'dd/MM/yy HH:mm') : ''}</div></td>
                            
                          {/* <td className="py-1 px-4">
                        <div className="flex justify-center gap-2">
                          <button
                            className=" bg-sky-700 rounded-full px-2 py-1 text-white text-sm"
                            onClick={()=>{}}
                          >
                            Atender
                          </button>
                          <button 
                            className=" bg-gray-700 rounded-full px-2 py-1 text-white text-sm"
                            onClick={()=>{}}
                          >
                            Gestão
                          </button>
                        </div>
                      </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>



              </div>

            </div>

            {/* Pagination Controls */}
            <div className="flex justify-center items-center mt-4 gap-2 text-xs">
                <button
                  onClick={() => handlePageChange(currentPageRequests - 1)}
                  disabled={currentPageRequests === 1}
                  className={`px-2 py-1 rounded-md ${currentPageRequests === 1 ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white'}`}
                >
                  {'<'}
                </button>

                {/* Botão para a primeira página */}
                {currentPageRequests > 2 && (
                  <>
                    <button
                      onClick={() => handlePageChange(1)}
                      className="px-2 py-1 rounded-md bg-gray-300"
                    >
                      1
                    </button>
                    {currentPageRequests >= 3 && <span className="px-2 py-1">...</span>}
                  </>
                )}

                {/* Botões ao redor da página atual */}
                {Array.from({ length: 3 }, (_, i) => {
                  const page = currentPageRequests - 1 + i;
                  if (page > 0 && page <= requestList.totalPages) {
                    return (
                      <button
                        key={page}
                        onClick={() => handlePageChange(page)}
                        className={`px-2 py-1 rounded-md ${page === currentPageRequests ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
                      >
                        {page}
                      </button>
                    );
                  }
                  return null;
                })}

                {/* Botão para a última página */}
                {currentPageRequests < requestList.totalPages - 1 && (
                  <>
                    {currentPageRequests < requestList.totalPages - 2 && <span className="px-2 py-1">...</span>}
                    <button
                      onClick={() => handlePageChange(requestList.totalPages)}
                      className="px-2 py-1 rounded-md bg-gray-300"
                    >
                      {requestList.totalPages}
                    </button>
                  </>
                )}

                <button
                  onClick={() => handlePageChange(currentPageRequests + 1)}
                  disabled={currentPageRequests === requestList.totalPages}
                  className={`px-2 py-1 rounded-md ${currentPageRequests === requestList.totalPages ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white'}`}
                >
                  {'>'}
                </button>
              </div>
            
          </div>

        </div>

      </div>

      {requestOnDetailsModal && 
        <div className="absolute">
          <RequestDetailsModal
            isModalOpen={requestDetailsModal}
            setModalOpen={() => {
              setRequestDetailsModal(!requestDetailsModal);
            }}
            requestId={requestOnDetailsModal}
            // setTicketCb={setTicket}
          ></RequestDetailsModal>
        </div>
      }

      {qualificacaoModalOpen && 
        <div className="absolute">
          <QualificacaoModal
            isModalOpen={qualificacaoModalOpen}
            setModalOpen={(open) => {
              setQualificacaoModalOpen(open);
              if (!open) handleSearch();
            }}
            requestId={qualificacaoRequestId}
          />
        </div>
      }

    </div>
  )
}
